// extracted by mini-css-extract-plugin
module.exports = {"MarketsOverviewPage":"markets-overview_MarketsOverviewPage__ZbJYd"};